import { cn } from "@/lib/utils";

export const Logo = ({ className, variant = "dark" }: { className?: string; variant?: "dark" | "light" }) => {
  const color = variant === "dark" ? "text-primary" : "text-primary-foreground";
  return (
    <div className={cn("flex items-center gap-2 font-display font-semibold tracking-tight", color, className)}>
      <span className="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-gradient-gold shadow-gold">
        <span className="font-display text-lg text-primary">T</span>
      </span>
      <span className="text-xl">
        Take <span className="text-accent">&</span> Pay
      </span>
    </div>
  );
};
